export default {
    checkFormFields(vueComp){
        vueComp.$nextTick(()=>{
            vueComp.formValid = true;
            let children = vueComp.$children;
            for (let i = 0; i < children.length; i++) {
                let child = children[i];
                let editInputChild = child.$refs.validationInput;
                if(editInputChild !== undefined) { // Check if component has editInputChild ref
                    editInputChild.validateSilent().then(result => {
                    // editInputChild.validate().then(result => {
                        vueComp.formValid &&= result.valid;
                    })
                }
            }
        })
    },
    validateChilds(vueComp){
        vueComp.$nextTick(()=>{
            vueComp.formValid = true;
            let children = vueComp.$children;
            for (let i = 0; i < children.length; i++) {
                let child = children[i];
                let editInputChild = child.$refs.validationInput;
                if(editInputChild !== undefined) { // Check if component has editInputChild ref
                    editInputChild.validate().then(result => {
                        // editInputChild.validate().then(result => {
                        vueComp.formValid &&= result.valid;
                    })
                }
            }
        })
    },
    checkFormFieldsSync(vueComp){
        // vueComp.$nextTick(()=>{
            vueComp.formValid = true;

            let editInputChilds = [];

            let children = vueComp.$children;
            for (let i = 0; i < children.length; i++) {
                let child = children[i];
                let editInputChild = child.$refs.validationInput;
                if(editInputChild !== undefined) { // Check if component has editInputChild ref
                    // editInputChild.validateSilent().then(result => {
                    //     // editInputChild.validate().then(result => {
                    //     vueComp.formValid &&= result.valid;
                    // })
                    editInputChilds.push(editInputChild);
                }
            }

            const recursive  = function (editInputChilds, i){
                return editInputChilds[i].validate().then(result => {
                    // editInputChild.validate().then(result => {
                    vueComp.formValid &&= result.valid;
                    i++;
                    if(i == editInputChilds.length){
                        return vueComp.formValid;
                    }
                    console.log(i);
                    return recursive(editInputChilds,i);
                    // return editInputChilds[i].validate();
                })
            }

            return recursive(editInputChilds, 0);

        // let i = 0;
        //     editInputChilds[i].validate().then(result => {
        //     // editInputChild.validate().then(result => {
        //         vueComp.formValid &&= result.valid;
        //         i++;
        //         if(i == editInputChilds.length){
        //             return vueComp.formValid;
        //         }
        //         return editInputChilds[i].validate();
        //     })
        // // })
    }
}